export const lockedMetrics = (i18nFilter) => [
    i18nFilter()("wa.ao.metric.dedup"),
    i18nFilter()("wa.ao.graph.dailymuv"),
    i18nFilter()("wa.ao.graph.monthlymuv"),
    i18nFilter()("wa.ao.graph.vpu"),
];
